<template>
  <div>
    <v-autocomplete
        v-model="center"
        :items="searchResults"
        :loading="isLoading"
        :search-input.sync="search"
        hide-no-data
        hide-selected
        item-text="desc"
        item-value="_id"
        :label="label !== '' ? label : $t('sportCenter')"
        :placeholder="$t('startTypingToSearch')"
        return-object
        @change="setResult()"
        chips
        small-chips
        deletable-chips
        :hint="(Array.isArray(searchResults) && searchResults.length === 0 && showHint) ? $t('noResults') : ''"
        :multiple="multiple"
    />
  </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: "CenterAutocomplete",
  props: {
    model: {
      default: () => ''
    },
    initValue: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
  },
  data: () => ({
    center: '',
    search: null,
    isLoading: false,
    searchResults: [],
    fullCentersList: [],
    showHint: false,
    waitingInitId: null
  }),
  created() {
    if (this.multiple) {
      if (Array.isArray(this.model)) {
        this.center = [...this.model];
      } else if (this.model && this.model._id) {
        this.center = [this.model];
      }
    } else {
      if (this.model && this.model._id) {
        this.center = { ...this.model };
      }
    }

    if (this.initValue) {
      this.setInitialFromId(this.initValue);
    }
  },
  mounted() {
    this.loadAllCenters();
  },
  watch: {
    initValue(newVal) {
      if (!newVal) return;

      if (Array.isArray(this.fullCentersList)) {
        const found = this.fullCentersList.find(c => c._id === newVal);
        if (found) {
          this.center = found;
        }
      } else {
        // In caso la lista non sia ancora pronta, salva l'ID da impostare dopo
        this.waitingInitId = newVal;
      }
    },
    search(val) {
      if (!val || val.length < 2) {
        this.searchResults = this.fullCentersList;
        this.showHint = false;
        return;
      }

      const searchTerm = val.toLowerCase();
      this.searchResults = this.fullCentersList.filter(center =>
          center.desc.toLowerCase().includes(searchTerm)
      );
      this.showHint = true;
    }
  },
  methods: {
    ...mapActions({
      getList: 'centers/getList'
    }),
    async loadAllCenters() {
      this.isLoading = true;
      try {
        const data = await this.getList()
        this.fullCentersList = data
        this.searchResults = data;
        if (this.initValue && !this.center) {
          const found = data.find(c => c._id === this.initValue);
          if (found) {
            this.center = found;
          }
        }

      } catch (err) {
        console.error('[CenterAutocomplete] Errore nel caricamento centri:', err);
      } finally {
        this.isLoading = false;
      }
    },
    setResult() {
      if (this.multiple) {
        const ids = (this.center || []).map(c => c._id);
        this.$emit('message', ids);
      } else {
        if (this.center && this.center._id) {
          this.$emit('message', this.center._id);
        } else {
          this.$emit('message', '');
        }
      }
    },
    setInitialFromId(id) {
      if (!Array.isArray(this.fullCentersList)) return;

      if (this.multiple) {
        const ids = Array.isArray(id) ? id : [id];
        const found = this.fullCentersList.filter(c => ids.includes(c._id));
        if (found.length) {
          this.center = found;
        }
      } else {
        const found = this.fullCentersList.find(c => c._id === id);
        if (found) {
          this.center = found;
        }
      }
    }
  }
};
</script>

<style scoped>

</style>
